{
    "SignInWith_Title": "S'identifier avec",
    "NAME": "SignInWith",
    "SignInWith_OtherOptions": "Connectez-vous en utilisant d'autres options"
}